<div>
  @if(isLoading) {
  <app-loading-indicator />
  } @else {
  <div class="control-row">
    <div class="control mx-5">
      <label class="mb-1" for="selectBehavior" style="font-weight: bold; color: #719eb6"
        >Selected Behavior(Depending on the type of the selected behavior, different graph types and options will be available):</label
      >
      <p-dropdown
        id="selectBehavior"
        styleClass="w-100 mb-3"
        appendTo="body"
        [options]="selectableBehaviors()"
        name="selectedBehavior"
        [checkmark]="true"
        optionLabel="text"
        optionValue="value"
        [showClear]="true"
        placeholder="Select a Behavior"
        [filter]="true"
        filterBy="text"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        [disabled]="isLoading"
        (onChange)="onBehaviorChange($event)"
        ><ng-template pTemplate="selectedBehavior" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.text }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <app-behavior-graph
    *ngIf="selectedBehavior != null || allBehaviorsSelected()"
    [patientID]="patientID()"
    [selectedBehavior]="selectedBehavior"
    [allBehaviorsSelected]="allBehaviorsSelected()"
  ></app-behavior-graph>
  }
</div>
